module.exports = __webpack_public_path__ + "static/media/contactTwo.8171fa36.jfif";